import dotenv from 'dotenv';

dotenv.config({ path: '.env.local' });
dotenv.config({ path: '.env.global.production' });
dotenv.config({ path: `.env.${process.env.MARKET}.production` });
